export default {
  // Page title
  title: 'Alert Settings',
  // Alert monitoring rules
  sectionAlertRule: 'Alert Monitoring Rules',
  alertEnabled: 'Function Switch',
  alertEnabledDesc:
    'When enabled, the system will automatically trigger an alert when a QR code reaches the set scan count.',
  scanCountThreshold: 'Scan Count Threshold',
  scanCountThresholdUnit: 'times',
  scanCountThresholdDesc: 'Set the scan count to trigger an alert.',
  // Auto disposal strategy
  sectionAutoDispose: 'Auto Disposal Strategy',
  autoDisposeEnabled: 'Function Switch',
  autoDisposeEnabledDesc:
    'When enabled, the system will automatically disable the QR code when an alert is triggered.',
  triggerCondition: 'Trigger Condition',
  triggerOnScanCount: 'When scan count alert is triggered',
  executeAction: 'Execute Disable Action',
  disableScopeSingle: 'Disable the alerted QR code only',
  disableScopeBatch: 'Disable all QR codes in the same batch',
  disableTip: 'Disable Tip (Consumer-side)',
  disableTipDesc: 'Set the message displayed to consumers when scanning a disabled QR code.',
  disableTipPlaceholder: 'Enter disable tip',
  // Save
  save: 'Save',
  saveSuccess: 'Saved successfully',
};
